import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { ListComponent } from '@app/common/templates/list/list.component';
import { Module } from '@app/models/permission';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { ExportService } from '@app/services/export.service';
import { SettingsService } from '@app/services/settings.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { TblVolumenCreateComponent } from '../create/create.component';
import { TblVolumenDetailComponent } from '../detail/detail.component';
import { TblVolumenEditComponent } from '../edit/edit.component';

@Component({
	templateUrl: './list.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/list/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblVolumenListComponent extends ListComponent {
	private allIncludingInactive: boolean = false;

	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public changeDetectorRef: ChangeDetectorRef,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public elRef: ElementRef,
		public exportService: ExportService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public settingsService: SettingsService,
		public translate: TranslateService,
		public dialogService: DialogService,
	) {
		super(accountService, breadcrumbService, changeDetectorRef, confirmationService, crudService, elRef, exportService, globals, messageService, router, settingsService, translate, dialogService);

		this.apiUrl = 'TblVolumen';
		this.name = 'MENU.VOLUMEN';
		this.url = '/' + PATH.VOLUMEN;
		this.module = Module.Masterdata;
		
		this.setCreateDialog(TblVolumenCreateComponent);
		this.setDetailDialog(TblVolumenDetailComponent);
		this.setEditDialog(TblVolumenEditComponent);


		this.possibleCols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'numeric', key: 'wert', required: false, width: 400 },
			{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
			{ type: 'text', key: 'barcode', required: false, width: 400 },
			{ type: 'text', key: 'barcode_text', required: false, width: 400 },
			{ type: 'numeric', key: 'barcode_ziffer', required: false, width: 400 },
			{ type: 'numeric', key: 'check_barcode_ziffer_index', required: false, width: 400 },
			{ type: 'numeric', key: 'check_barcode_ziffer_laenge', required: false, width: 400 },
			{ type: 'text', key: 'barcode_ziffer_text', required: false, width: 400 },
		];
		this.cols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'numeric', key: 'wert', required: false, width: 400 },
		];

		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.LIST', routerLink: [this.url + '/' + PATH.LIST] }
		]);
	}

	switchArchivierte() {
		this.allIncludingInactive = !this.allIncludingInactive;
		this.getAllEntries();
	}

	// override
	getAllEntries() {
		this.loading += 1;
		this.messageService.clear('refresh');
		if (this.allIncludingInactive) {
			this.crudService.getAllVolumesIncludingInactive().then(res => {
				this.processEntries(res);
				this.resizeTableWidthFromContent(false);
			}).catch(err => {
				err.error.forEach(e => {
					this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
				})
			}).finally(() => {
				this.loading -= 1;
			});
		} else {
			this.crudService.getAllEntries(this.apiUrl).then(res => {
				this.processEntries(res);
				this.resizeTableWidthFromContent(false);
			}).catch(err => {
				err.error.forEach(e => {
					this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
				})
			}).finally(() => {
				this.loading -= 1;
			});
		}
	}
}
